import React from "react";
import { JSX } from "react/jsx-runtime";

const ThumbsDownIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="38" height="35" viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_1433_21)">
            <ellipse cx="18.5366" cy="17.1853" rx="18.5366" ry="17.1853" fill="#F2F2F7"/>
            <path d="M18.5361 0.5C28.5338 0.5 36.5732 8.00549 36.5732 17.1855C36.5731 26.3655 28.5337 33.8701 18.5361 33.8701C8.53879 33.8699 0.500156 26.3653 0.5 17.1855C0.5 8.00563 8.5387 0.500226 18.5361 0.5Z" stroke="#FF453A" stroke-opacity="0.5"/>
            <path d="M16.7637 19.5072H11.9997C11.6588 19.5072 11.3236 19.4263 11.0259 19.2721C10.7281 19.1179 10.4778 18.8956 10.2985 18.6263C10.1193 18.3569 10.0172 18.0495 10.0018 17.7332C9.9864 17.4169 10.0583 17.1021 10.2107 16.8189L13.7107 10.3164C13.8768 10.0075 14.1323 9.74779 14.4485 9.56631C14.7646 9.38484 15.129 9.28879 15.5007 9.28895H19.5177C19.6807 9.28895 19.8437 9.30753 20.0027 9.34469L23.7637 10.2179M16.7637 19.5072V24.1519C16.7637 24.6446 16.9744 25.1172 17.3495 25.4656C17.7245 25.814 18.2332 26.0098 18.7637 26.0098H18.8587C19.3587 26.0098 19.7637 25.6335 19.7637 25.1691C19.7637 24.5058 19.9747 23.8574 20.3717 23.3056L23.7637 18.5783V10.2179M16.7637 19.5072H18.7637M23.7637 10.2179H25.7637C26.2941 10.2179 26.8028 10.4136 27.1779 10.762C27.553 11.1105 27.7637 11.583 27.7637 12.0758V17.6494C27.7637 18.1421 27.553 18.6147 27.1779 18.9631C26.8028 19.3115 26.2941 19.5072 25.7637 19.5072H23.2637" stroke="#FF453A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_1433_21">
            <rect width="38" height="34.3706" fill="white"/>
            </clipPath>
        </defs>
    </svg>

  );
};

export default ThumbsDownIcon; 